module.exports = __webpack_public_path__ + "img/FR42559.1a0100b5.png";